import { useEffect, useRef } from "react";
import ActionRow from "../components/v2/ActionRow";
import HelperLine from "../components/v2/HelperLine";
import PageTransition from "../components/v2/PageTransition";
import QuestionCounter from "../components/v2/QuestionCounter";
import QuestionLabel from "../components/v2/QuestionLabel";
import TextInput from "../components/v2/TextInput";
import Wordmark from "../components/v2/Wordmark";
import "../components/v2/v2-question-surface.css";

export const SURFACE_15_LABEL = "Tell me about a time you saw them light up.";
export const SURFACE_15_HELPER = "A moment, a memory, a story — whatever comes to mind.";
export const SURFACE_15_PLACEHOLDER = "Take your time…";
export const SURFACE_15_ERROR = "Even a few words helps. Tell us about that moment.";

export default function Surface15({
  value,
  error,
  direction = "forward",
  onChange,
  onBlur,
  onBack,
  onNext,
  editMode = false,
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    const reduceMotion =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const timer = window.setTimeout(() => {
      inputRef.current?.focus();
    }, reduceMotion ? 200 : 360);

    return () => window.clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (error) inputRef.current?.focus();
  }, [error]);

  const nextDisabled = !String(value || "").trim();

  return (
    <section className="tgc-v2-surface tgc-v2-surface--textarea" aria-labelledby="question-label">
      <PageTransition direction={direction}>
        <div className="tgc-v2-content">
          <Wordmark variant="stacked" />
          <QuestionCounter current={11} total={12} />
          <QuestionLabel>{SURFACE_15_LABEL}</QuestionLabel>
          <HelperLine id="surface-15-helper">{SURFACE_15_HELPER}</HelperLine>

          <div className="tgc-v2-field-wrap tgc-v2-field-wrap--textarea">
            <TextInput
              ref={inputRef}
              value={value}
              variant="left-aligned"
              multiline
              rows={6}
              error={error}
              name="recipient_light_up"
              autoComplete="off"
              enterKeyHint="enter"
              autoCapitalize="sentences"
              spellCheck="true"
              maxLength={2000}
              placeholder={SURFACE_15_PLACEHOLDER}
              aria-labelledby="question-label"
              aria-describedby={error ? "surface-15-helper surface-15-error" : "surface-15-helper"}
              onChange={(event) => onChange(event.target.value)}
              onBlur={onBlur}
            />
            <div className="tgc-v2-error" id="surface-15-error" aria-live="polite">
              {error ? SURFACE_15_ERROR : ""}
            </div>
          </div>

          <div className="tgc-v2-action-row--textarea">
            <ActionRow
              variant={editMode ? "done-only" : "two-button"}
              onBack={onBack}
              onNext={onNext}
              nextDisabled={nextDisabled}
              nextLabel={editMode ? "Done" : "Next"}
            />
          </div>
        </div>
      </PageTransition>
    </section>
  );
}
